export function toNumber(value: string | number): number {
  const parsedValue = typeof value === 'string' ? (!value ? 0 : Number.parseFloat(value)) : value;

  return Number.isFinite(parsedValue) && !Number.isNaN(parsedValue) ? parsedValue : 0.0;
}
